<div [attr.aria-multiselectable]="multiselectable" class="panel-group" [id]="id" role="tablist">
  <ng-content></ng-content>
</div>
